import  {Box, Center, Spinner} from '@chakra-ui/react';

function SpinnerXL(){
    return(
        <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            bg="rgba(255, 255, 255, 0.8)" 
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex="2000" 
        >
            <Center>
                <Spinner size="xl" />
            </Center>
        </Box>
    )
}

export default SpinnerXL;

